import { AddressEditScreen } from '../features/account/AddressEditScreen'

export function ProfileAddressEditPage() {
  return <AddressEditScreen />
}
